module.exports = __webpack_public_path__ + "img/button-bg.00722fc.jpg";